// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/laser-illumination.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/laser-illumination/laser-illumination.js';

mount([g0]);
